import o from"styled-components";const e=o.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;export{e as ImageContainer};
